import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    queueName?: string;
    agentFullName?: string;
    compact?: boolean;
    // Suppresses the "→ <agent>" suffix; used by the personal call history list
    // where the answering agent is always the logged-in user, so naming them is
    // redundant noise.
    showAnsweringAgent?: boolean;
}

const QueueCallInfo = ({
    queueName,
    agentFullName,
    compact,
    showAnsweringAgent = true,
}: Props) => {
    if (queueName) {
        return (
            <QueueAndAgentRow
                queueName={queueName}
                agentFullName={agentFullName}
                compact={compact}
                showAnsweringAgent={showAnsweringAgent}
            />
        );
    }
    return (
        <AgentRow
            agentFullName={agentFullName}
            showAnsweringAgent={showAnsweringAgent}
        />
    );
};

const QueueAndAgentRow = ({
    queueName,
    agentFullName,
    compact,
    showAnsweringAgent,
}: {
    queueName: string;
    agentFullName?: string;
    compact?: boolean;
    showAnsweringAgent: boolean;
}) => {
    const { i18next } = useAppContext();
    return (
        <span className={compact ? 'block truncate' : ''}>
            {i18next.t('call.to')}{' '}
            <span className="text-main">{queueName}</span>
            {showAnsweringAgent && agentFullName && (
                <>
                    {document.dir === 'rtl' ? ' ← ' : ' → '}
                    <span className="text-main">{agentFullName}</span>
                </>
            )}
        </span>
    );
};

const AgentRow = ({
    agentFullName,
    showAnsweringAgent,
}: {
    agentFullName?: string;
    showAnsweringAgent: boolean;
}) => {
    const { i18next } = useAppContext();
    if (!showAnsweringAgent || !agentFullName) return null;
    return (
        <span>
            {`${i18next.t('call.to')} `}
            <span className="text-main">{agentFullName}</span>
        </span>
    );
};

export default QueueCallInfo;
